import { render, staticRenderFns } from "./UsuariosComponent.vue?vue&type=template&id=0242b73b&"
import script from "./UsuariosComponent.vue?vue&type=script&lang=js&"
export * from "./UsuariosComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports